import React, { useEffect, useState, useContext} from 'react';
import cl from './Add.module.css'; 
import Select from "react-select"; 
import { selectStyle } from './selectStyle';
import { AppContext } from '../../../../providers/appProvider';
import MultiSelect from '../../../UI/Inputs/MultiSelect';
import DatePicker from "react-datepicker"; 
import 'react-datepicker/dist/react-datepicker.css';
import '../../../../assets/Style/Datepicker.css'; 
import moment from 'moment';

const AddParser = ({ parserService }) => {

    const years = [];
    const startYear = 2014;
    const currentYear = new Date().getFullYear();

    for (let year = currentYear; year >= startYear; year--) {
        years.push({ value: year.toString(), label: year.toString() });
    }
 
    const { appState, app } = useContext(AppContext);


    const parserResetData = {
        saler_id: '',
        website_id: '', 
        maker_id: '',
        model_id: '' ,
        year_from: startYear, 
        year_to:  currentYear, 
        start_at: new Date(new Date().getTime() + 5 * 60 * 1000),  // Current time plus 5 minutes
        limit:  300, 
    };

    const [newParser, setNewParser] = useState(parserResetData);
    const [isFirstValidated, setIsFirstValidated] = useState(false);
    const [validates, setValidates] = useState({});

    const salers = appState.salers.map((user) => ({ value: user.id, label: user.firstname + " " + user.lastname })); 

    var websites = [
        { value: 1, label: "auctionwini.com" },
        { value: 2, label: "autowini.com" }, 
      ];
    

      const validateParser = (parser) => {
        const messages = {};
    
        if (parser.saler_id < 1) {
            messages.saler_id = { message: 'სავალდებულოა', isValid: false };
        }
    
        if (parser.website_id < 1) {
            messages.website_id = { message: 'სავალდებულოა', isValid: false };
        }
    
        if (parser.maker_id < 1) {
            messages.maker_id = { message: 'სავალდებულოა', isValid: false };
        }
    
        if (parser.model_id < 1) {
            messages.model_id = { message: 'სავალდებულოა', isValid: false };
        }
     
    
        const isValid = Object.keys(messages).length === 0;
        setValidates(messages);
        return isValid;
    };    

    useEffect(() => {
        if (isFirstValidated) {
            validateParser(newParser);
        }
        
    }, [newParser, isFirstValidated]);

    const saveHandle = () => {
        const isValidate = validateParser(newParser);
        if (isValidate) { 

            const parserDataToSubmit = {
                ...newParser,
                start_at:   moment(newParser.start_at).format('YYYY-MM-DD HH:mm:ss')  
            }; 

            parserService.add(parserDataToSubmit); 
            setIsFirstValidated(false);  
            setValidates({});  
            setNewParser(parserResetData);  
            
        } else {
            setIsFirstValidated(true);
        }
    };

 
    
    const setMakerModel = async ( makerId, modelId) => {
 
        setNewParser(prevState => ({
        
            ...prevState,
            maker_id: makerId ? makerId : 0,
            model_id: modelId ? modelId.toString() : "0"
        }))
    
    
    }
    


    const stylesError = { 
        control: (provided, state) => ({
            ...provided,
            border: state.isFocused ? '1px solid rgb(225 29 72)' : '1px solid rgb(225 29 72)',
            boxShadow: state.isFocused ? 'none' : 'none',
            '&:hover': {
                border: state.isFocused ? '1px solid rgb(225 29 72)' : '1px solid rgb(225 29 72)',  
            },
            minHeight: "35px",
            width: '100%',
            cursor: 'pointer',
            borderRadius: '5px',
        }),

    };
 


    const days = ['ორ', 'სა', 'ოთ', 'ხუ', 'პა', 'შა', 'კვ']
    const months = ['იან', 'თებ', 'მარ', 'აპრ', 'მაი', 'ივნ', 'ივლ', 'აგვ', 'სექ', 'ოქტ', 'ნოე', 'დეკ']

    const locale = {
        localize: {
            day: n => days[n],
            month: n => months[n]
        },
        formatLong: {
            date: () => 'MM/dd/yyyy',
            dateTime: () => 'MM/dd/yyyy HH:mm:ss', 
            time: () => 'HH:mm'  
        }
    };
 
 

    return (
        <div className={cl.container}>

            <div className={cl.row}>

                <div className={cl.col}>

                    <div className={`${cl.groupInput} ${validates.saler_id ? cl.errorInput : ''}`}>
                        <label>სელერი  </label>
                        
                        <Select
                            styles={validates && validates.saler_id ? { ...selectStyle, ...stylesError } : selectStyle}
                            options={salers}  
                            value={salers.find(option => option.value === newParser.saler_id) || null}
                            onChange={(selectedOption) => {
                                setNewParser(prevState => ({
                                ...prevState,
                                saler_id: selectedOption ? selectedOption.value : null,
                            }));

                            }}
                            isClearable={true}
                            placeholder=""
                        /> 
                         
                    </div>
                </div>


                <div className={cl.col}>

                    <div className={`${cl.groupInput} ${validates.website_id ? cl.errorInput : ''}`}>
                        <label>ვებ-გვერდი</label>
                                                
                        <Select
                            styles={validates && validates.website_id ? { ...selectStyle, ...stylesError } : selectStyle}
                            options={websites} 
                            value={websites.find(option => option.value === newParser.website_id) || null}
                            onChange={(selectedOption) => {
                                setNewParser(prevState => ({
                                ...prevState,
                                website_id: selectedOption ? selectedOption.value : 0,
                                }));
                            }}
                            isClearable={true}
                            placeholder=""
                        /> 
  
                    </div>
                </div>



                <div className={cl.col +' '+ cl.col2}>

                    <div className={`${cl.groupInput} ${validates.website_id ? cl.errorInput : ''}`}>
                                                 
                        <MultiSelect
                            parentOptions={appState.makers}
                            childOptions={appState.models}
                            parentId={newParser.maker_id || null }
                            childId={newParser.model_id || null}
                            childIsMulti={true}
                            styles={selectStyle}
                            onChange={setMakerModel}
                            join={"maker_id"}
                            topTitle
                            placeholder="მწარმოებელი"
                            placeholderSub="მოდელი" 
                            validate={validates.maker_id?.isValid === false ? true : false}
                            validateSub={validates.model_id?.isValid === false ? true : false}
                        />
 
                       
                    </div>
                </div>

 
                <div className={cl.col}>

                    <div className={`${cl.groupInput}`}>
                        <label>წელი</label>

                        <div className={cl.row}>
                            <div className={cl.col} style={{paddingRight: '2px'}}> 
                            <Select 
                                styles={validates && validates.year_from ? { ...selectStyle, ...stylesError } : selectStyle}
                                options={years}
                                placeholder="დან"
                                value={years.find(option => option.value === newParser.year_from.toString())}
                                onChange={(selectedOption) => {
                                    setNewParser(prevState => ({
                                        ...prevState,
                                        year_from: selectedOption ? Number(selectedOption.value) : newParser.year_from.toString(),
                                    }));
                                }} 
                            />
 
                            </div> 

                            <div className={cl.col} style={{paddingLeft: '2px'}}> 
                                <Select 
                                    styles={validates && validates.year_to ? { ...selectStyle, ...stylesError } : selectStyle}
                                    options={years}
                                    placeholder="მდე"
                                    value={years.find(option => option.value === newParser.year_to.toString())}
                                    onChange={(selectedOption) => {
                                        setNewParser(prevState => ({
                                            ...prevState,
                                            year_to: selectedOption ? Number(selectedOption.value) : newParser.year_to.toString(),
                                        }));
                                    }} 
                                />
                            </div> 
    

                        </div>       
                    </div>       
                </div>       

      
                <div className={cl.col}>
                    <div className={`${cl.groupInput}`}>
    
                    <label>გაშვება</label>

                        <DatePicker 
                            locale={locale}
                            selected={newParser.start_at} 
                            dateFormat={'d MMM yyyy HH:mm'}
                            showTimeSelect={true}
                            timeFormat="HH:mm"  
                            timeIntervals={15}     
                        

                            minDate={new Date()}
                            minTime={newParser.start_at && newParser.start_at.toDateString() === new Date().toDateString() ? new Date() : new Date(0, 0, 0, 0, 0)} 
                            maxTime={new Date(0, 0, 0, 23, 45)}
    
                            onKeyDown={(e) => {
                                e.preventDefault();
                            }}

                            onChange={(date) => { 
                                setNewParser(prevState => ({
                                    ...prevState, 
                                    start_at: date
                                }));
                            }}
                
                            popperClassName={cl.dataContainer}
                            wrapperClassName={cl.dataContainer}
                            dataContainer={cl.dataContainer }
                            className={validates && validates.start_at ? cl.input+' '+ cl.errorInput : cl.input }
    
                        />


    
                    </div> 
                </div> 
      
                <div className={cl.col}>  
                    <div className={`${cl.groupInput}`}>
                        <input
                            type="text"
                            className={validates && validates.name ? cl.input + ' ' + cl.errorInput : cl.input}
                            value={newParser.limit} 
                            autoComplete="off"
                            onChange={(e) => {
                                const val = parseInt(e.target.value, 10);  
                                setNewParser(prevState => ({
                                    ...prevState,
                                    limit: val,  
                                }));
                            }}
                        />
 
                        <label>ლიმიტი</label>

                    </div> 
                </div> 
      
                <div className={cl.colSmall}>             
                    <span onClick={saveHandle} className={cl.btnPrimary}>დამატება</span>
                </div> 
                 
            </div>
             
        </div>
    );
};

export default AddParser;
